import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, useMediaQuery, Box } from "@mui/material";
import TestimoniesSlider from "./TestimoniesSlider";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    marginTop: "1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100vw",
    justifyContent: "center",
    borderRadius: "0 0 100px 0",
    marginBottom: "79px",
    overFLow: "hidden",
  },
  title: {
    color: theme.palette.red.main,
    fontWeight: "600",
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: { xs: "14px", md: "16px" },
    textAlign: "center",
  },
  subtitle: {
    maxWidth: { xs: "283px", md: "750px", lg: "900px" },
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "32px", md: "52px", lg: "65px" },
    lineHeight: { xs: "36px", md: "63px", lg: "82px" },
    textAlign: "center",
    mt: "19px",
  },
  span: { fontWeight: "bold" },
  sliderTestimonies: {
    marginTop: "2.5rem",
    width: isMobile ? "100%" : "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    mt: "76px",
    display: { md: "flex" },
    justifyContent: { md: "center" },
    alignItems: { md: "center" },
  },
});

const Testimonies = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle } = useTranslation(pathname, "Testimonies");

  return (
    <div style={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>

      <Typography sx={classes.subtitle}>
        {subtitle[0]}
        <span style={classes.span}>{subtitle[1]}</span>
        {subtitle[2]}
      </Typography>
      <TestimoniesSlider />
    </div>
  );
};

export default Testimonies;
